// extracted by mini-css-extract-plugin
export var label = "_d3-5";
export var slideContainer = "_d3-0";
export var slider = "_d3-1";
export var sliderLg = "_d3-4";
export var sliderMd = "_d3-3";
export var sliderSm = "_d3-2";